import { acceptHMRUpdate, defineStore } from "pinia"

export const useKeeCreditsModalStore = defineStore("keeCreditsModal", {
  state: () => {
    return {
      isInsufficientCreditsDialogOpen: false,
    }
  },
  actions: {
    openInsufficientCreditsDialog() {
      this.isInsufficientCreditsDialogOpen = true
    },
    closeInsufficientCreditsDialog() {
      this.isInsufficientCreditsDialogOpen = false
    },
  },
})

if (import.meta.hot) {
  // @ts-ignore
  import.meta.hot.accept(acceptHMRUpdate(useKeeCreditsModalStore, import.meta.hot))
}
